import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "const/axios";

const BASE = "/bank-accounts";

export const useBankAccounts = (options = {}) => {
  return useQuery({
    queryKey: ["bankAccounts"],
    queryFn: async () => (await axios.get(BASE)).data,
    ...options,
  });
};

export const useCreateBankAccount = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => (await axios.post(BASE, payload)).data,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ["bankAccounts"] });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
};

export const useUpdateBankAccount = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...payload }) => (await axios.put(`${BASE}/${id}`, payload)).data,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ["bankAccounts"] });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
};

export const useDeleteBankAccount = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => axios.delete(`${BASE}/${id}`),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ["bankAccounts"] });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
};
